import React, {FC, useState, useEffect} from "react"

import {ButtonRouterLink} from "@irati/ui/src/Link"
import Flex from "@irati/ui/src/Flex"
import {useTheme} from "@irati/ui/src/global/useTheme"
import Card from "@irati/ui/src/Layout/Card"
import {H3} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import PropTypes from "prop-types"
import {FlexiPointsExpiry, PaymentCurrencyType, WalletEntityType} from "@irati/types"
import {daysLeft, pointsExpiryVariables} from "@irati/wallet/helpers/expiry"
import walletService from "@irati/wallet/graph/wallet"
import flexiPointService from "@irati/wallet/services/flexiRewards"
import authentication from "@irati/auth"
import Spacing from "@irati/ui/src/Spacing"

import {CalendarHeader, CalendarBody, CalendarWrapper} from "./styled"

const ExpiryInformationBanner: FC = (_, {apps}) => {
  const [expiredFlexiPoints, setExpiredFlexiPoints] = useState<FlexiPointsExpiry | null>(null)
  const {colors} = useTheme()
  const {uuid = ""} = authentication.user()

  useEffect(() => {
    walletService.get(uuid, PaymentCurrencyType.Rp, WalletEntityType.Reward, {fetchPolicy: "network-only"}).then((wallet) => {
      if (wallet.uuid && wallet.amount) {
        flexiPointService.flexiPointsExpiryList(pointsExpiryVariables(wallet.uuid, PaymentCurrencyType.Rp)).then(setExpiredFlexiPoints)
      }
    })
  }, [])

  if (!expiredFlexiPoints?.total) {
    return null
  }

  return (
    <Spacing paddingTop={5}>
      <Card bgColor={colors.utility.bgWarning} as="article">
        <Flex gap={2} justifyContent="space-between" alignItems="center">
          <Flex direction="column" alignItems="flex-start" gap={2} flex="1 1 70%">
            <H3>
              <FormattedMessage id="platform.homepage.expiryBanner.title" />
            </H3>
            <ButtonRouterLink to="/flexi-reward" app={apps.WALLET}>
              <FormattedMessage id="platform.ui.banner.cta.text" />
            </ButtonRouterLink>
          </Flex>

          <CalendarWrapper flex="1 1 30%">
            <Card flush>
              <CalendarHeader>
                <FormattedMessage id="platform.homepage.expiryBanner.calendar.header" />
              </CalendarHeader>
              <CalendarBody>{daysLeft(expiredFlexiPoints.breakdown![0].expiresAt!)}</CalendarBody>
            </Card>
          </CalendarWrapper>
        </Flex>
      </Card>
    </Spacing>
  )
}

ExpiryInformationBanner.contextTypes = {
  apps: PropTypes.object.isRequired
}

export default ExpiryInformationBanner
